// dogAttributeApi.js — wrappers for the /dog-attributes and /admin/dog-attributes endpoints

import { apiRequest } from './api';

/**
 * Fetch all dog attributes, optionally filtered by type.
 * @param {string|undefined} type — 'BREED' | 'SIZE' | 'ENERGY_LEVEL' (omit for all)
 * @returns {Promise<Array>}
 */
export const getDogAttributes = (type) => {
  const params = new URLSearchParams();
  if (type) params.set('type', type);
  const qs = params.toString();
  return apiRequest(`/dog-attributes${qs ? `?${qs}` : ''}`);
};

/**
 * Fetch a single dog attribute by ID.
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const getDogAttributeById = (id) => apiRequest(`/dog-attributes/${id}`);

/**
 * Create a new dog attribute (admin only).
 * @param {{ type: string, nameEn: string, nameHe?: string, nameEs?: string }} data
 * @returns {Promise<Object>}
 */
export const createDogAttribute = (data) =>
  apiRequest('/admin/dog-attributes', {
    method: 'POST',
    body: JSON.stringify(data),
  });

/**
 * Update an existing dog attribute (admin only). Type is immutable.
 * @param {number} id
 * @param {{ nameEn: string, nameHe?: string, nameEs?: string }} data
 * @returns {Promise<Object>}
 */
export const updateDogAttribute = (id, data) =>
  apiRequest(`/admin/dog-attributes/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  });

/**
 * Delete a dog attribute (admin only).
 * Returns 409 if the attribute is referenced by any dog or meet_group.
 * @param {number} id
 * @returns {Promise<void>}
 */
export const deleteDogAttribute = (id) =>
  apiRequest(`/admin/dog-attributes/${id}`, { method: 'DELETE' });
